module.exports = __webpack_public_path__ + "static/media/galerija_2014 (18).dc7106b1.jpg";